import { createContext } from 'react';

export interface CommonContextInterface {
	setShowDialog: (x: any) => void;
	setShowSnackbar: (x: any) => void;
	hasComponentAccess: (componentName: string) => boolean;
	AccessControlComponent?: (x: any) => React.JSX.Element | null | undefined;
	AccessControlledComponents: any;
	organizationId: number | null;
	apolloHeaders?: { [key: string]: string };
}

const defaultCommonContext = {
	organizationId: null,
	setShowDialog: () => {},
	setShowSnackbar: () => {},
	hasComponentAccess: () => false,
	AccessControlComponent: null,
	AccessControlledComponents: null,
	apolloHeaders: {},
} as CommonContextInterface;

export const CommonContext = createContext(defaultCommonContext);
